import { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { Outlet, useNavigate } from "react-router-dom";
import { tokenTestReq } from "Requests/User.req";
import socketStore from "stores/socketStore";
import userStore from "stores/userStore";

const AuthLayout = () => {
  const navigate = useNavigate();

  const [authorizing, setAuthorizing] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const user = userStore((state) => state);
  const autoGenerated = useMemo(() => user.autoGenerated, [user]);

  const testToken = async () => {
    try {
      const result = await tokenTestReq();
      console.log(result);
      setAuthorized(true);
    } catch (err) {
      console.error(err);
      toast.error("오류가 발생했습니다.");
    } finally {
      setAuthorizing(false);
    }
  };

  useEffect(() => {
    if (autoGenerated) {
      if (user.token != null) {
        // TODO :: verify token
        setAuthorized(true);
      }
      setAuthorizing(false);
    } else {
      testToken();
    }
  }, [user, autoGenerated]);

  useEffect(() => {
    if (authorizing) return;
    if (!authorized) {
      navigate("/entry");
    }
  }, [authorized, authorizing, navigate]);

  return <Outlet />;
};

export default AuthLayout;
